/* ============================================================
   RIDA COLLECTION — INLINE QUICK-ADD (v2 — Fast)
   JSON body, instant UI feedback, async cart drawer refresh
   ============================================================ */
(function(){
  'use strict';

  function fastAddToCart(variantId, quantity) {
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    }).then(function(res) {
      if (!res.ok) throw new Error('Add failed');
      return res.json();
    });
  }

  function refreshCartDrawer() {
    /* Update badge count immediately from cart API */
    fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        /* Update all cart count badges */
        document.querySelectorAll('.cart-count-badge, [data-cart-count], .cart-drawer__title-counter').forEach(function(el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.classList.remove('hidden');
        });
      }).catch(function(){});

    /* Open the quick-cart-drawer (this theme's cart element) */
    var qcd = document.querySelector('quick-cart-drawer');
    if (qcd && typeof qcd.open === 'function') {
      qcd.open();
      return;
    }
    /* Fallback: click the cart link in the header */
    var cartLink = document.querySelector('[data-cart-link]');
    if (cartLink) { cartLink.click(); }
  }

  /* Mobile toggle */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.rida-quickadd__mobile-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var panel = trigger.closest('.product-card__actions').querySelector('.rida-quickadd');
      if (panel) {
        document.querySelectorAll('.rida-quickadd.is-visible').forEach(function(p) {
          if (p !== panel) p.classList.remove('is-visible');
        });
        panel.classList.toggle('is-visible');
      }
      return;
    }
    if (window.innerWidth < 750 && !e.target.closest('.rida-quickadd') && !e.target.closest('.rida-quickadd__mobile-trigger')) {
      document.querySelectorAll('.rida-quickadd.is-visible').forEach(function(p) {
        p.classList.remove('is-visible');
      });
    }
  });

  /* Size button click */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.rida-quickadd__size-btn');
    if (!btn || btn.classList.contains('is-sold-out') || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    btn.classList.add('is-loading');
    btn.textContent = '';
    fastAddToCart(variantId, 1)
      .then(function() {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = '';
        refreshCartDrawer();
        setTimeout(function() {
          btn.classList.remove('is-added');
          btn.textContent = btn.getAttribute('data-size-label');
        }, 1500);
      })
      .catch(function() {
        btn.classList.remove('is-loading');
        btn.textContent = btn.getAttribute('data-size-label');
      });
  });

  /* Single-variant ATC */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.rida-quickadd__atc');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var origText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fastAddToCart(variantId, 1)
      .then(function() {
        btn.textContent = 'Added ✓';
        refreshCartDrawer();
        setTimeout(function() {
          btn.textContent = origText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function() {
        btn.textContent = origText;
        btn.disabled = false;
      });
  });


  /* ── Complete the Set — size button ATC (inside IIFE, fastAddToCart in scope) ─ */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.rida-rec-card__size-btn');
    if (!btn || btn.disabled || btn.classList.contains('is-sold-out')) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    var sizeLabel = btn.getAttribute('data-size-label');
    if (!variantId) return;

    btn.textContent = '...';
    btn.disabled = true;

    fastAddToCart(variantId, 1)
      .then(function() {
        btn.textContent = '✓';
        btn.classList.add('is-added');
        refreshCartDrawer();
        setTimeout(function() {
          btn.textContent = sizeLabel;
          btn.classList.remove('is-added');
          btn.disabled = false;
        }, 1500);
      })
      .catch(function() {
        btn.textContent = sizeLabel;
        btn.disabled = false;
      });
  });

  /* ── Complete the Set — single-variant ATC ─────────────────────────────────── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.rida-rec-card__atc[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    var orig = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    fastAddToCart(variantId, 1)
      .then(function() {
        btn.textContent = '✓ Added';
        refreshCartDrawer();
        setTimeout(function() {
          btn.textContent = orig;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function() {
        btn.textContent = orig;
        btn.disabled = false;
      });
  });

})();
